import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';

import { useState, useRef, useEffect } from 'react';
import { useCallback } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import attach2Fill from '@iconify/icons-eva/attach-2-fill';
import roundThumbUp from '@iconify/icons-ic/round-thumb-up';
import checkmarkFill from '@iconify/icons-eva/checkmark-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
import moreHorizontalFill from '@iconify/icons-eva/more-horizontal-fill';
// material

import { MobileDateRangePicker, LoadingButton } from '@material-ui/lab';
import { styled } from '@material-ui/core/styles';

import {
    Box,
    Stack,
    Drawer,
    Button,
    Avatar,
    Tooltip,
    Divider,
    MenuItem,
    TextField,
    Typography,
    OutlinedInput,
    Grid,
    Card,
    Tabs,
    Tab,
    Paper,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Input,
    FilledInput,
    InputAdornment
} from '@material-ui/core';
//

import { MIconButton, MHidden } from '../../../components/@material-extend';
import apiContact from '../../../api/contact';
import apiUser from '../../../api/user';
import apiTicket from '../../../api/ticket';
import { useSnackbar } from 'notistack5';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------
import useAuth from '../../../hooks/useAuth'
import { objectID } from '../../../utils/objectID';
import { useDispatch, useSelector } from 'react-redux';

import { capitalCase } from 'change-case';
import Scrollbar from '../../../components/Scrollbar';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { set } from 'lodash';
import { getAllFieldTicket } from '../../../redux/slices/ticket';
import { hoursToDays } from '../../../utils/hoursToDays';
import { minutesToDays } from '../../../utils/minutesToDay';
import { secondsToDays } from '../../../utils/secondsToDays';
const PRIORITIZES = ['low', 'medium', 'hight'];

FTicket.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    card: PropTypes.object,
    onDeleteTask: PropTypes.func
};

const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.body2,
    width: 140,
    fontSize: 13,
    flexShrink: 0,
    color: theme.palette.text.secondary
}));

// ----------------------------------------------------------------------

export default function FTicket({ listUser, isOpen, onClose, formik, isReadOnly, selectedTicket }) {
    const { enqueueSnackbar } = useSnackbar();
    const inputRef = useRef();
    const { t } = useTranslation();
    const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;
    const { fieldTicket } = useSelector(state => state.ticket)

    const [newSupportDept, setNewSupportDept] = useState("");
    const [newProjectType, setNewProjectType] = useState("");
    const [colorTag, setColorTag] = useState("#fff");
    const dispatch = useDispatch();
    const { user } = useAuth();
    // useEffect(() => {
    //     const loadFieldTicket = async () => {
    //         try {
    //             const res_field_ticket = await apiTicket.viewAllFieldTicket();
    //             setFieldTicket(res_field_ticket.data.data)
    //         } catch (error) {

    //         }
    //     }
    //     loadFieldTicket();


    // }, []);
    const action_add_support_dept = async () => {
        try {

            const res_add_support_dept = await apiTicket.add_field_ticket({ key: "support_dept", value: newSupportDept })
            enqueueSnackbar("Tạo thành công", { variant: 'success' });
            dispatch(getAllFieldTicket());
        } catch (error) {
            enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
        }
    }
    const action_add_project_type = async () => {
        try {
            const res_add_project_type = await apiTicket.add_field_ticket({ key: "project_type", value: newProjectType })
            enqueueSnackbar("Tạo thành công", { variant: 'success' });
            dispatch(getAllFieldTicket());
        } catch (error) {
            enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
        }
    }
    const onHandleChangeFieldTicket = async (e) => {
        if (e.target.name === "new_support_dept") {
            setNewSupportDept(e.target.value)
        }
        if (e.target.name === "new_project_type") {
            setNewProjectType(e.target.value)
        }
    }
    const handleChange = (e) => {
        setFieldValue(e.target.name, e.target.value)
    }
    const onHandleColorTag = (e) => {
        setColorTag(e.target.value)
    }
    return (
        <>
            <Box
                // sx={{
                //     '& > :not(style)': { m: 1 },
                // }}
                fullWidth
            >
                <Grid container rowSpacing={2} columnSpacing={{ px: 1 }}>
                    <Grid item xs={12}>
                        <Stack direction={"row"} justifyContent={'stretch'} spacing={1}>
                            <TextField
                                size="small"
                                disabled={isReadOnly}
                                id="full-width-text-field"
                                label="Bộ phận hỗ trợ"
                                placeholder="Bộ phận hỗ trợ"
                                //  helperText="Full width!"
                                name="support_dept"
                                select
                                fullWidth
                                onChange={handleChange}
                                error={Boolean(touched.support_dept && errors.support_dept)}
                                helperText={touched.support_dept && errors.support_dept}
                                defaultValue={values.support_dept}
                                value={values.support_dept}
                                SelectProps={{
                                    MenuProps: {
                                        sx: { maxHeight: 200 }
                                    }
                                }}

                            >
                                {/* {user?.is_admin === 1 && <>
                                    <Divider />
                                    <Stack direction={"column"} sx={{ p: 0.5 }} spacing={1} >
                                        <OutlinedInput
                                            onKeyDown={e => e.stopPropagation()}
                                            fullWidth
                                            multiline
                                            rows={1}
                                            size="small"
                                            name="new_support_dept"
                                            placeholder="Tạo mới"
                                            sx={{ typography: 'body2' }}
                                            onChange={onHandleChangeFieldTicket}
                                        />
                                        <Button fullWidth variant="contained" color="success" onClick={() => action_add_support_dept()}>
                                            Thêm mới
                                        </Button>
                                    </Stack>
                                    <Divider />
                                </>} */}

                                {fieldTicket?.length > 0 && fieldTicket?.filter(item => item?.field_variable === "support_dept")[0].field_options.map((field, index) => {
                                    return (
                                        <MenuItem Icon key={index} value={field?.key}>
                                            <Typography>{field?.label}</Typography>
                                        </MenuItem>
                                    )
                                })}
                            </TextField>
                            <TextField
                                size="small"
                                disabled={isReadOnly}
                                id="full-width-text-field"
                                label="Loại công việc"
                                placeholder="Loại công việc"
                                name="project_type"
                                //  helperText="Full width!"
                                onChange={handleChange}
                                select
                                fullWidth
                                defaultValue={values.project_type}
                                value={values.project_type}
                                SelectProps={{
                                    MenuProps: {
                                        sx: { maxHeight: 200 }
                                    }
                                }}
                            >
                                {/* {user?.is_admin === 1 && <>
                                    <Divider />
                                    <Stack direction={"column"} sx={{ p: 0.5 }} spacing={1} >
                                        <OutlinedInput
                                            onKeyDown={e => e.stopPropagation()}
                                            fullWidth
                                            multiline
                                            rows={1}
                                            size="small"
                                            placeholder="Tạo mới"
                                            name="new_project_type"
                                            sx={{ typography: 'body2' }}
                                            onChange={onHandleChangeFieldTicket}
                                        />
                                        <Button fullWidth variant="contained" color="success" onClick={() => action_add_project_type()}>
                                            Thêm mới
                                        </Button>
                                    </Stack>
                                    <Divider />
                                </>} */}
                                {fieldTicket?.length > 0 && fieldTicket?.filter(item => item?.field_variable === "project_type")[0].field_options.map((field, index) => {
                                    return (
                                        <MenuItem key={index} value={field?.key}>{field?.label}</MenuItem>
                                    )
                                })}
                            </TextField>
                            <TextField
                                size="small"
                                disabled={isReadOnly}
                                id="full-width-text-field"
                                label="Tên công việc"
                                placeholder="Tên công việc"
                                name="project_name"
                                //   helperText="Full width!"
                                fullWidth
                                {...getFieldProps('project_name')}
                                error={Boolean(touched.project_name && errors.project_name)}
                                helperText={touched.project_name && errors.project_name}
                                defaultValue={values.project_name}
                            />

                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            size="small"
                            disabled={isReadOnly}
                            id="full-width-text-field"
                            label="Nội dung công việc"
                            placeholder="Nội dung công việc"
                            rows={3}
                            //    helperText="Full width!"
                            fullWidth
                            {...getFieldProps('project_content')}
                            error={Boolean(touched.project_content && errors.project_content)}
                            helperText={touched.project_content && errors.project_content}
                            defaultValue={values.project_content}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        {fieldTicket?.length > 0 && fieldTicket?.filter(item => item?.field_variable === "project_type")[0].field_options.map((field, index) => {
                            if (field.key === values.project_type) {
                                if (field.time === "custom" || selectedTicket) {
                                    return (
                                        <Stack direction={"row"} justifyContent={'stretch'} spacing={1}>
                                            <TextField
                                                size="small"
                                                disabled={isReadOnly}
                                                name="start_date"
                                                label="Ngày bắt đầu"
                                                InputLabelProps={{ shrink: true, required: true }}
                                                type="datetime-local"
                                                fullWidth
                                                {...getFieldProps('date_start')}
                                                error={Boolean(touched.date_start && errors.date_start)}
                                                helperText={touched.date_start && errors.date_start}
                                                defaultValue={values.date_start}
                                            />
                                            <TextField
                                                size="small"
                                                disabled={isReadOnly}
                                                fullWidth
                                                name="end_date"
                                                label="Ngày kết thúc"
                                                InputLabelProps={{ shrink: true, required: true }}
                                                type="datetime-local"
                                                {...getFieldProps('date_end')}
                                                error={Boolean(touched.date_end && errors.date_end)}
                                                helperText={touched.date_end && errors.date_end}
                                                defaultValue={values.date_end}
                                            />
                                        </Stack>
                                    )
                                } else {
                                    return (
                                        <TextField fullWidth inputProps={{ readOnly: true }} label="Thời gian xử lý" defaultValue={field.time === "hour" ? hoursToDays(field.timeline) : field.time === "minute" ? minutesToDays(field.timeline) : field.time === "day"?field.timeline + ' ngày':secondsToDays(field.timeline)}></TextField>
                                    )
                                }
                            }

                        })}


                    </Grid>
                </Grid>
                {/* <TextField id="filled-basic" label="Filled" variant="filled" />
                <TextField id="standard-basic" label="Standard" variant="standard" /> */}
            </Box>
        </>
    );
}
